import type { Company } from '../@types/Company';
import { getCompanyDisplayName } from './company';

export function buildCompanyBlogUrl(company: Company): string {
  const origin = window.location.origin;
  return `${origin}/blog/company/${company.siren}`;
}

/**
 * Get the blog/newsletter URL for a company, using external URL if configured
 * @param company - The company object
 * @returns The external newsletter URL if configured, otherwise the default blog URL
 */
export function getCompanyNewsletterUrl(company: Company): string {
  const firstReferent = company.brandingSettings?.referents?.[0];
  if (firstReferent?.hasExternalNewsletter && firstReferent?.externalNewsletterUrl) {
    return firstReferent.externalNewsletterUrl;
  }
  return buildCompanyBlogUrl(company);
}

export function buildUnsubscribeUrl(company: Company): string {
  const origin = window.location.origin;
  return `${origin}/unsubscribe/${company.siren}`;
}

export function buildSuggestedMailText(company: Company, newsletterTitle: string, newsletterDate?: string): string {
  const companyName = getCompanyDisplayName(company);

  const lines: string[] = [];
  lines.push(`Objet :  la newsletter ${companyName} – ${newsletterDate || ''}`);
  lines.push('');
  lines.push('Chers Copropriétaires,');
  lines.push('');
  lines.push('Informer les copropriétaires sur la gestion et les règles de la vie en copropriété fait partie des missions légales du syndic (loi du 10 juillet 1965).');
  lines.push('');
  lines.push('Notre newsletter que vous trouverez en pièce jointe, va plus loin : expliquer, décrypter et rendre plus accessibles certains aspects parfois complexes de la vie en copropriété.');
  lines.push('');
  lines.push(`Dans ce numéro, nous faisons un focus sur un sujet essentiel : ${newsletterTitle}.`);
  lines.push('');
  lines.push('Nous espérons que cette lecture vous sera utile et agréable. Bien sûr, notre équipe reste à votre disposition.  Si vous avez des questions ou des suggestions pour les prochaines éditions, Nous sommes toujours à votre écoute.');
  lines.push('');
  lines.push('Bonne lecture et à très bientôt,');
  lines.push('');
  lines.push(`L'équipe ${companyName}`);
  lines.push('Votre syndic de copropriété');
  lines.push('');
  lines.push('');
  lines.push(`Voir le blog d'information en ligne : ${getCompanyNewsletterUrl(company)}`);
  lines.push('');
  lines.push('');
  lines.push('Pour vous désinscrire et ne plus recevoir cette newsletter :');
  lines.push(buildUnsubscribeUrl(company));

  return lines.join('\n');
}

export function buildSciUnsubscribeUrl(company: Company): string {
  const origin = window.location.origin;
  return `${origin}/sci-unsubscribe/${company.siren}`;
}

export function buildZipFilenameFromTitle(title: string): string {
  return title.replaceAll(/[\\/:*?"<>|]/g, '_');
}


